/**
 * The possible signal levels
 */
export enum SIGNAL_LEVEL {
    ERROR,
    VERY_LOW,
    LOW,
    OK,
    GOOD,
    EXCELLENT,
    UNKNOWN,
}

/**
 * The lowest thresholds for the signal levels, in terms of % packet loss
 *
 * Note the ERROR threshold is not represented here in signal level calculation. It is used only
 * when the device is not communicating and is offline.
 */
export const SIGNAL_LEVEL_THRESHOLDS = {
    [SIGNAL_LEVEL.VERY_LOW]: 0.8,
    [SIGNAL_LEVEL.LOW]: 0.4,
    [SIGNAL_LEVEL.OK]: 0.28,
    [SIGNAL_LEVEL.GOOD]: 0.15,
    [SIGNAL_LEVEL.EXCELLENT]: 0,
};

/**
 * Packet loss at or below this is treated as no measurement yet. Gen4/Sprout network info
 * defaults uplink/downlink loss to 0 until enough packets have been collected.
 */
export const UNINITIALIZED_PACKET_LOSS_CEILING = 0.000001;
